(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // --- Collection Customizer (upload + preview + validation) ---
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-collection-customizer]');
    if (!root) return;

    const fileInput = root.querySelector('[data-customizer-file]');
    const drop = root.querySelector('[data-customizer-drop]');
    const img = root.querySelector('[data-customizer-img]');
    const plus = root.querySelector('[data-customizer-plus]');
    const removeBtn = root.querySelector('[data-customizer-remove]');
    const errorBox = root.querySelector('[data-customizer-error]');
    const maxMb = Number(root.getAttribute('data-max-mb') || '10');
    const maxBytes = maxMb * 1024 * 1024;

    const setError = (msg) => {
      if (!errorBox) return;
      errorBox.textContent = msg || '';
      errorBox.classList.toggle('hidden', !msg);
    };

    const showPreview = (file) => {
      if (!file) return;
      const url = URL.createObjectURL(file);
      img.src = url;
      img.style.display = 'block';
      plus.style.display = 'none';
      removeBtn.classList.remove('hidden');
    };

    const clearPreview = () => {
      if (fileInput) fileInput.value = '';
      if (img) {
        img.removeAttribute('src');
        img.style.display = 'none';
      }
      if (plus) plus.style.display = 'block';
      if (removeBtn) removeBtn.classList.add('hidden');
      setError('');
    };

    const validateFile = (file) => {
      if (!file) return false;

      const allowed = ['image/png', 'image/jpeg', 'image/jpg'];
      // Some browsers may report jpg as image/jpeg, so we allow both.
      const isAllowed =
        allowed.includes(file.type) ||
        file.name.toLowerCase().endsWith('.jpg') ||
        file.name.toLowerCase().endsWith('.jpeg') ||
        file.name.toLowerCase().endsWith('.png');

      if (!isAllowed) {
        setError('Only PNG or JPG files are allowed.');
        return false;
      }
      if (file.size > maxBytes) {
        setError(`File is too large. Max ${maxMb}MB.`);
        return false;
      }
      setError('');
      return true;
    };

    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        if (!validateFile(file)) {
          clearPreview();
          return;
        }
        showPreview(file);
      });
    }

    if (drop && fileInput) {
      drop.addEventListener('click', () => fileInput.click());
      drop.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') fileInput.click();
      });

      // drag & drop
      drop.addEventListener('dragover', (e) => {
        e.preventDefault();
        drop.classList.add('is-dragover');
      });
      drop.addEventListener('dragleave', () =>
        drop.classList.remove('is-dragover')
      );
      drop.addEventListener('drop', (e) => {
        e.preventDefault();
        drop.classList.remove('is-dragover');
        const file =
          e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!file) return;
        if (!validateFile(file)) {
          clearPreview();
          return;
        }
        // Put it into the input so Shopify captures it on submit
        const dt = new DataTransfer();
        dt.items.add(file);
        fileInput.files = dt.files;
        showPreview(file);
      });
    }

    if (removeBtn) removeBtn.addEventListener('click', clearPreview);

    // Require upload before submit
    const form = root.querySelector('form');
    if (form && fileInput) {
      form.addEventListener('submit', (e) => {
        const file = fileInput.files && fileInput.files[0];
        if (!file) {
          e.preventDefault();
          setError('Please upload an image before adding to cart.');
          drop?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!validateFile(file)) {
          e.preventDefault();
          return;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
